import { Route, Routes } from "react-router-dom";
import {
  ActivityLog,
  ActivityLogTabBar,
  ActivityLogUser,
  AddPoint,
  AddQuestions,
  Admins,
  Agendas,
  AllReservations,
  AnswerReport, // check
  ApprovalRequests,
  Assets,
  // AssetsCards,
  AssetsDesign,
  AssetTypes,
  Attendance,
  AttendeeUsers,
  Blacklist,
  Buffet,
  BuffetGroups,
  BuffetOrders,
  BuffetOrdersHistory,
  BuffetProducts,
  BugTickets,
  CCTV,
  ChangePassword,
  ChannelHistory,
  Channels,
  ChannelUsers,
  ClientQrCodeRedirct,
  ClientStatistics,
  Companies,
  ConditionalRoute,
  ContactPerson,
  Countries,
  Holidays,
  Courses,
  CoursesCategory,
  DeletedAssets,
  DeletedAssetTypes,
  DeletedBuffet,
  DeletedBuffetGroups,
  DeletedBuffetOrders,
  DeletedChannels,
  DeletedContactPerson,
  DeletedCourses,
  DeletedDepartments,
  DeletedDevices,
  DeletedDrugsTest,
  DeletedFloors,
  DeletedGroups,
  DeletedPoints,
  DeletedQrcard,
  DeletedReports,
  DeletedRooms,
  DeletedSalaryRecord,
  DeletedSectors,
  DeletedSegments,
  DeletedServiceProviders,
  DeletedShifts,
  DeletedSites,
  DeletedStaff,
  DeletedStaffBlackList,
  DeletedStaffSalary,
  DeletedUsers,
  DepartmentsRoute, // check
  DepartmentsShiftsRoute, // check
  DepartmentsShiftUsersRoute, //check
  Devices,
  DrugsTest,
  DrugTestResult,
  EditCompany,
  EyeStatistics,
  FixedTickets,
  // EmployeeCard,
  Floors,
  FMStatistics,
  FTEStatistics,
  GeneralProfile,
  GroupChats,
  Groups,
  GroupUsers,
  GuideBooks,
  HomeLayout,
  JobRolesRoute, // check
  LateRequestsAttendance,
  Login,
  // Meetings,
  Minutes,
  MinutesOfMeetings,
  MyBuffetOrders,
  MyPermissions,
  MyTickets,
  NewReportForm,
  NotFixedTickets,
  NotFound,
  OperationPlan,
  OperationPlanPoints,
  OperationPlanReport,
  OperationPlanTasks,
  OrderBuffet,
  OvertimeRequests,
  PointCard,
  PointDesign,
  // DrawCanvas,
  PointDraw,
  Points,
  PrivateChats,
  PrivateChatsHistory,
  Profile,
  Providers,
  // VisitorsBlackList,
  PublicSettings,
  Qrcard,
  QrCardColors,
  QrcardDesign,
  Qrcode,
  Reports,
  ReportsAnswers,
  RequestOvertime,
  RequestVacation,
  ReservationRequests,
  ReservationStatus,
  RoomDetails,
  // Home,
  // OurWork,
  // AboutUs,
  // ContactUs,
  RoomReservations,
  Rooms,
  RoomsReservation,
  SectorsRoute,
  SegmentsRoute,
  SendTicket,
  Services,
  ShiftsRoute, // check
  SinglePrivateChat,
  SinglePrivateChatUser,
  Sites,
  SOSHistory,
  SOSHistoryVideos,
  Staff,
  StaffDesign,
  StaffGPS,
  StaffGPSUsers,
  StaffGPSUsersEditMap,
  StaffOutOfLocation, //check
  StaffSalary,
  Statistics,
  StockingAssets,
  StructureAssets,
  StructurePoints,
  StructureStockingAssets,
  Subscriptions,
  Tasks,
  ThreeD,
  TicketDetails,
  Tickets,
  TicketsDetails,
  TicketsSettings,
  Transaction,
  TransactionContainerLocations,
  TransactionContainers,
  TransactionContainersCategories,
  TransactionStatus,
  TransactionStatusCategories,
  UnderReviewingTickets,
  UserDashboard,
  UserLogin,
  Users,
  VacationRequests,
  VehiclesGPS,
  Version,
  WalkieTalkieHistory,
  WorkingActivity,
} from ".";
import VisitorsBlackList from "./dashboard/visitorsBlackList/VisitorsBlackList.route";

import { Suspense } from "react";
import LoadingData from "../components/loadingData/loadingData.component";
import StaffDocuments from "./dashboard/staffDocuments/StaffDocuments.route";
import VacationRequestTypes from "./dashboard/vacationRequestTypes/VacationRequestTypes.route";
import SalaryRecord from "./dashboard/salaryRecord/SalaryRecord.route";
import DeletedGuidebooks from "./dashboard/deletedGuidebooks/DeletedGuidebooks";
import DeletedSOSRequests from "./dashboard/DeletedSOSRequests/DeletedSOSRequests";
import NewReportsAnswers from "./dashboard/reportsAnswers/newReportsAnswers.route";
import Apps from "./admin/dashboard/apps/Apps.route";
import SecurityPlan from "./dashboard/securityPlan/SecurityPlan.route";
import SecurityTasks from "./dashboard/securityTasks/SecurityTasks.route";
import SecurityTaskAnswers from "./dashboard/securityTaskAnswers/SecurityTaskAnswers.route";
import SecurityTaskLogs from "./dashboard/securityTasks/SecurityTaskLogs.route";
import SecurityPlanTasks from "./dashboard/securityPlanTasks/securityPlanTasks";
import SecurityPlanLogs from "./dashboard/securityPlanLogs/securityPlanLogs";
import SecurityPlansAttendance from "./dashboard/SecurityPlansAttendance/SecurityPlansAttendance.route";
import MyVisitorRequests from "./dashboard/visitors/MyVisitorRequests.route";
import VisitorRequests from "./dashboard/visitors/VisitorRequests.route";
import VisitorRequestsHistory from "./dashboard/visitors/VisitorRequestsHistory.route";
import VisitorEntryExit from "./dashboard/visitors/VisitorEntryExit.route";
import VisitorEntryExitLogs from "./dashboard/visitors/VisitorEntryExitLogs.route";
import AdminSites from "./dashboard/sites/AdminSites.route";
// import Testing from "./testing/Testing.route";

// import Admins from "./admin/dashboard/admins/admins.route";

export type Permissions = {
  ApproveRequests?: CRUD;
  Assets?: CRUD;
  AssetsType?: CRUD;
  BlackLists?: CRUD;
  Channels?: CRUD;
  Chats?: CRUD;
  Courses?: CRUD;
  CoursesCategories?: CRUD;
  Devices?: CRUD;
  DrugTest?: CRUD;
  DrugTestResults?: CRUD;
  ActivityLog: CRUD;
  Floors?: CRUD;
  Groups?: CRUD;
  GuideBooks?: CRUD;
  Points?: CRUD;
  ReportAnswers?: CRUD;
  Reports?: CRUD;
  Rooms?: CRUD;
  Sectors?: CRUD;
  Sites?: CRUD;
  StaffAttendance?: CRUD;
  Staffs?: CRUD;
  Statistics?: CRUD;
  Users?: CRUD;
  Providers?: CRUD;
  QrContainers?: CRUD;
  ReportQuestions?: CRUD;
  UsersGPS?: CRUD;
  VehiclesGPS?: CRUD;
  CCTV?: CRUD;
  Departments?: CRUD;
  PrivateChat?: CRUD;
  PrivateChatHistory?: CRUD;
  Shifts?: CRUD;
  RoomReservations: CRUD;
  ContactPersons: CRUD;
  Profile: CRUD;
  DeleteMessages: CRUD;
  HomeLayout: CRUD;
  VisitorBlackLists: CRUD;
  Transactions: CRUD;
  ActivityLogsAllUsers: CRUD;
  JobRoles: CRUD;
  WorkConfirmation: CRUD;
  AnswerReport: CRUD;
  VacationRequest: CRUD;
  Supervisors: CRUD;
  OrderBuffet: CRUD;
  Buffet: CRUD;
  BuffetOrders: CRUD;
  BuffetGroups: CRUD;
  AssetsStocking: CRUD;
  Clients: CRUD;
  Segments: CRUD;
  StaffSalary: CRUD;
  StaffSalaryRecord: CRUD;
  [key: string]: CRUD | undefined;
};
export type CRUD = {
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
};

const routes = (
  isASDCAdmin: boolean | undefined,
  isUser: boolean | undefined,
  permissions: Permissions
) => (
  <Routes>
    <Route
      path="/admin/login"
      element={
        <ConditionalRoute
          Element={<Login />}
          condition={isASDCAdmin === undefined ? undefined : !isASDCAdmin}
          redirectTo="/admin/dashboard"
        />
      }
    ></Route>
    <Route
      path="/admin/dashboard"
      element={
        <ConditionalRoute
          Element={<Companies />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/app-version"
      element={
        <ConditionalRoute
          Element={<Version />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/services"
      element={
        <ConditionalRoute
          Element={<Services />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/apps"
      element={
        <ConditionalRoute
          Element={<Apps />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/subscriptions"
      element={
        <ConditionalRoute
          Element={<Subscriptions />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/admins"
      element={
        <ConditionalRoute
          Element={<Admins />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/countries"
      element={
        <ConditionalRoute
          Element={<Countries />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/holidays"
      element={
        <ConditionalRoute
          Element={<Holidays />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/segments"
      element={
        <ConditionalRoute
          Element={<SegmentsRoute />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/segments/sectors/:segmentId"
      element={
        <ConditionalRoute
          Element={<SectorsRoute />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/segments/sectors/:segmentId/sites/:sectorId"
      element={
        <ConditionalRoute
          Element={<AdminSites />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>

    <Route
      path="/admin/bug-tickets"
      element={
        <ConditionalRoute
          Element={<BugTickets />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    >
      <Route path="under-reviewing" element={<UnderReviewingTickets />} />
      <Route path="fixed" element={<FixedTickets />} />
      <Route path="not-fixed" element={<NotFixedTickets />} />
      <Route path="under-reviewing/:ticketId" element={<TicketDetails />} />
      <Route path="fixed/:ticketId" element={<TicketDetails />} />
      <Route path="not-fixed/:ticketId" element={<TicketDetails />} />
    </Route>
    <Route
      path="/admin/contracts/:id"
      element={
        <ConditionalRoute
          Element={<Statistics />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/edit/:qrcode"
      element={
        <ConditionalRoute
          Element={<EditCompany disabled={false} />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/admin/info/:qrcode"
      element={
        <ConditionalRoute
          Element={<EditCompany disabled={true} />}
          condition={isASDCAdmin}
          redirectTo="/admin/login"
        />
      }
    ></Route>
    <Route
      path="/login"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <UserLogin />
        </Suspense>
      }
    ></Route>
    <Route
      path="/"
      element={
        <ConditionalRoute
          Element={<UserDashboard permissions={permissions} />}
          condition={isUser}
          redirectTo="/login"
          welcomeLoading="dashboard"
        />
      }
    >
      <Route path="" element={<HomeLayout />}>
        <Route path="site-layout" element={<ThreeD opacity={true} />} />
        {/* <Route path="site-layout/add-point/:floorId" element={<AddPoint />} /> */}
        <Route
          path="staff-gps"
          element={
            <ConditionalRoute
              Element={<StaffGPS />}
              condition={permissions?.UsersGPS?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="staff-gps/users-out-of-location"
          element={
            <ConditionalRoute
              Element={<StaffOutOfLocation />}
              condition={permissions?.UsersGPS?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="staff-gps/users/:status"
          element={
            <ConditionalRoute
              Element={<StaffGPSUsers />}
              condition={permissions?.UsersGPS?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="staff-gps/users/editSiteMap/:sectorId/:siteId"
          element={
            <ConditionalRoute
              Element={<StaffGPSUsersEditMap />}
              condition={permissions?.UsersGPS?.update}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="vehicles-gps"
          element={
            <ConditionalRoute
              Element={<VehiclesGPS />}
              condition={permissions?.VehiclesGPS?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="cctv"
          element={
            <ConditionalRoute
              Element={<CCTV />}
              condition={permissions?.CCTV?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="statistics"
          element={
            <ConditionalRoute
              Element={<ClientStatistics />}
              condition={permissions?.Statistics?.read}
              redirectTo="/site-layout"
            />
          }
        ></Route>
      </Route>
      {/* Mr Ibrahim Request */}
      <Route
        path="structure"
        element={
          <ConditionalRoute
            Element={<SegmentsRoute />}
            condition={permissions?.Segments?.read}
            redirectTo="/site-layout"
          />
        }
      ></Route>
      <Route
        path="deleted-segments"
        element={
          <ConditionalRoute
            Element={<DeletedSegments />}
            condition={permissions?.Segments?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId"
        element={
          <ConditionalRoute
            Element={<SectorsRoute />}
            condition={permissions?.Sectors?.read}
            redirectTo="/site-layout"
          />
        }
      ></Route>
      <Route
        path="deleted-sectors"
        element={
          <ConditionalRoute
            Element={<DeletedSectors />}
            condition={permissions?.Sectors?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId"
        element={
          <ConditionalRoute
            Element={<Sites />}
            condition={permissions?.Sites?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/stocking-assets/:siteQRCode"
        element={
          <ConditionalRoute
            Element={<StockingAssets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-sites"
        element={
          <ConditionalRoute
            Element={<DeletedSites />}
            condition={permissions?.Sites?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId"
        element={
          <ConditionalRoute
            Element={<Floors />}
            condition={permissions?.Floors?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/stocking-assets/:floorQRCode"
        element={
          <ConditionalRoute
            Element={<StockingAssets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-floors"
        element={
          <ConditionalRoute
            Element={<DeletedFloors />}
            condition={permissions?.Floors?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/add-point/:floorId"
        element={
          <ConditionalRoute
            Element={<AddPoint opacity={true} />}
            condition={permissions?.Points?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/points/:floorId"
        element={
          <ConditionalRoute
            Element={<Points />}
            condition={permissions?.Points?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-points"
        element={
          <ConditionalRoute
            Element={<DeletedPoints />}
            condition={permissions?.Points?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/points/:floorId/draw"
        element={
          <ConditionalRoute
            Element={<PointDraw />}
            condition={permissions?.Points?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/points/:floorId/:pointId"
        element={
          <ConditionalRoute
            Element={<PointCard />}
            condition={permissions?.Points?.update}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/points/:floorId/point-design/:pointId"
        element={
          <ConditionalRoute
            Element={<PointDesign />}
            condition={permissions?.Points?.update}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId"
        element={
          <ConditionalRoute
            Element={<Rooms />}
            condition={permissions?.Rooms?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-rooms"
        element={
          <ConditionalRoute
            Element={<DeletedRooms />}
            condition={permissions?.Rooms?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId/assets/:roomId"
        element={
          <ConditionalRoute
            Element={<Assets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-assets"
        element={
          <ConditionalRoute
            Element={<DeletedAssets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* <Route
          path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId/assets/:roomId/:assetId"
          element={
            <ConditionalRoute
              Element={<AssetsCards />}
              condition={permissions?.Assets?.update}
              redirectTo="/site-layout"
            />
          }
        /> */}
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId/assets/:roomId/asset-design/:assetId"
        element={
          <ConditionalRoute
            Element={<AssetsDesign />}
            condition={permissions?.Assets?.update}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId/stocking-assets/:roomQRCode"
        element={
          <ConditionalRoute
            Element={<StockingAssets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* <Route
          path="structure/sectors/:segmentId/sites/:sectorId/floors/:siteId/rooms/:floorId/:roomId/:assetId"
          element={
            <ConditionalRoute
              Element={<AssetsCards />}
              condition={permissions?.Assets?.update}
              redirectTo="/site-layout"
            />
          }
        /> */}
      {/*  Providers */}
      <Route
        path="providers"
        element={
          <ConditionalRoute
            Element={<Providers />}
            condition={permissions?.Providers?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-service-providers"
        element={
          <ConditionalRoute
            Element={<DeletedServiceProviders />}
            condition={permissions?.Providers?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="providers/employee/:providerId"
        element={
          <ConditionalRoute
            Element={<StaffDesign />}
            condition={
              permissions?.Providers?.update || permissions?.Staffs?.update
            }
            redirectTo="/site-layout"
          />
        }
      />
      {/* <Route
        path="structure/sectors/:segmentId/providers/:sectorId"
        element={
          <ConditionalRoute
          Element={<Providers />}
          condition={permissions?.Providers?.read}
          redirectTo="/site-layout"
          />
          }
          />
          <Route
          path="deleted-service-providers"
          element={
            <ConditionalRoute
            Element={<DeletedServiceProviders />}
            condition={permissions?.Providers?.read}
            redirectTo="/site-layout"
            />
            }
            />
            <Route
            path="structure/sectors/:segmentId/providers/:sectorId/employee/:providerId"
            element={
              <ConditionalRoute
              Element={<StaffDesign />}
              condition={
                permissions?.Providers?.update || permissions?.Staffs?.update
                }
                redirectTo="/site-layout"
                />
                }
                /> */}
      {/* <Route
        path="structure/sectors/:segmentId//:sectorId/employee/:providerId"
        element={
          <ConditionalRoute
          Element={<EmployeeCard />}
          condition={
            permissions?.Providers?.update || permissions?.Staffs?.update
            }
            redirectTo="/site-layout"
            />
            }
            /> */}
      <Route
        path="security-plans"
        element={
          <ConditionalRoute
            Element={<SecurityPlan />}
            condition={permissions?.SecurityPost?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="security-plans/:securityPostId"
        element={
          <ConditionalRoute
            Element={<SecurityTasks />}
            condition={permissions?.SecurityPostTask?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="security-plans/:securityPostId/answers/:taskId"
        element={
          <ConditionalRoute
            Element={<SecurityTaskAnswers />}
            condition={permissions?.SecurityPostTaskAnswers?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="security-plans/:securityPostId/security-task-logs/:securityPostTaskId"
        element={
          <ConditionalRoute
            Element={<SecurityTaskLogs />}
            condition={permissions?.SecurityPostTaskLogs?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="security-plans-attendance"
        element={
          <ConditionalRoute
            Element={<SecurityPlansAttendance />}
            condition={permissions?.SecurityPost?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="security-tasks"
        element={
          <ConditionalRoute
            Element={<SecurityPlanTasks />}
            condition={permissions?.SecurityPostTask?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="security-logs"
        element={
          <ConditionalRoute
            Element={<SecurityPlanLogs />}
            condition={permissions?.SecurityPostTaskLogs?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="stockingAssets"
        element={
          <ConditionalRoute
            Element={<StructureStockingAssets />}
            condition={permissions?.AssetsStocking?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="points"
        element={
          <ConditionalRoute
            Element={<StructurePoints />}
            condition={permissions?.Points?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="assets"
        element={
          <ConditionalRoute
            Element={<StructureAssets />}
            condition={permissions?.Assets?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="departments"
        element={
          <ConditionalRoute
            Element={<DepartmentsRoute />}
            condition={permissions?.Departments?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-departments"
        element={
          <ConditionalRoute
            Element={<DeletedDepartments />}
            condition={permissions?.Departments?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="departments/:departmentId"
        element={
          <ConditionalRoute
            Element={<DepartmentsShiftsRoute />}
            condition={permissions?.Departments?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="departments/:departmentId/shift/:shiftId"
        element={
          <ConditionalRoute
            Element={<DepartmentsShiftUsersRoute />}
            condition={permissions?.Departments?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="users"
        element={
          <ConditionalRoute
            Element={<Users />}
            condition={permissions?.Users?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-users"
        element={
          <ConditionalRoute
            Element={<DeletedUsers />}
            condition={permissions?.Users?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* <Route path="filemanager" element={<FileManager />}></Route> */}
      <Route path="eye-statistics" element={<EyeStatistics />} />
      <Route path="fm-statistics" element={<FMStatistics />} />
      <Route path="fte-statistics" element={<FTEStatistics />} />
      <Route path="qrcode" element={<Qrcode />}></Route>
      <Route
        path="guidebooks"
        element={
          <ConditionalRoute
            Element={<GuideBooks />}
            condition={permissions?.GuideBooks?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route path="qrcode" element={<Qrcode />}></Route>
      <Route
        path="deleted-guidebooks"
        element={
          <ConditionalRoute
            Element={<DeletedGuidebooks />}
            condition={permissions?.GuideBooks?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-sos-requests"
        element={
          <ConditionalRoute
            Element={<DeletedSOSRequests />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      {/* Reports */}
      <Route
        path="reports"
        element={
          <ConditionalRoute
            Element={<Reports />}
            condition={permissions?.Reports?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="sos-history"
        element={
          <ConditionalRoute
            Element={<SOSHistory />}
            condition={isUser}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="sos-history/videos/:id"
        element={
          <ConditionalRoute
            Element={<SOSHistoryVideos />}
            condition={isUser}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="walkie-talkie-history"
        element={
          <ConditionalRoute
            Element={<WalkieTalkieHistory />}
            condition={isUser}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-reports"
        element={
          <ConditionalRoute
            Element={<DeletedReports />}
            condition={permissions?.Reports?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="answer_report"
        element={
          <ConditionalRoute
            Element={<AnswerReport />}
            condition={permissions?.AnswerReport?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="request-overtime"
        element={
          <ConditionalRoute
            Element={<RequestOvertime />}
            condition={permissions?.MakeRequestOvertime?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* my overtime requests */}
      <Route
        path="my-overtime-requests"
        element={
          <ConditionalRoute
            Element={<OvertimeRequests />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="request-vacation"
        element={
          <ConditionalRoute
            Element={<RequestVacation />}
            condition={permissions?.MakeRequestVacation?.read}
            redirectTo="/site-layout"
          />
        }
      />

      {/* my vactions requests */}
      <Route
        path="my-vacation-requests"
        element={
          <ConditionalRoute
            Element={<VacationRequests />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="order-buffet"
        element={
          <ConditionalRoute
            Element={<OrderBuffet />}
            condition={permissions?.OrderBuffet?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="my-buffet-orders"
        element={
          <ConditionalRoute
            Element={<MyBuffetOrders />}
            condition={permissions?.OrderBuffet?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="reportsAnswers"
        element={
          <ConditionalRoute
            // Element={<ReportsAnswers />}
            Element={<NewReportsAnswers />}
            // TODO: change this later
            condition={permissions?.ReportAnswers?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="reportsAnswers/form/:formId"
        element={
          <ConditionalRoute
            Element={<NewReportForm />}
            condition={permissions?.ReportAnswers?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="operation-plan-report"
        element={
          <ConditionalRoute
            Element={<OperationPlanReport />}
            condition={true} // TODO: change this later
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="report/addQuestions/:id"
        element={
          <ConditionalRoute
            Element={<AddQuestions />}
            condition={permissions?.ReportQuestions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route path="qrcard" element={<Qrcard />} />
      <Route path="deleted-qrcard" element={<DeletedQrcard />} />
      <Route path="qrcard/:qrcode" element={<QrCardColors />} />
      <Route path="qrcard/qrcardDesign/:qrcode" element={<QrcardDesign />} />
      <Route
        path="requests"
        element={
          <ConditionalRoute
            Element={<ApprovalRequests />}
            condition={permissions?.ApproveRequests?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="devices"
        element={
          <ConditionalRoute
            Element={<Devices />}
            condition={permissions?.Devices?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-devices"
        element={
          <ConditionalRoute
            Element={<DeletedDevices />}
            condition={permissions?.Devices?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="staff"
        element={
          <ConditionalRoute
            Element={<Staff />}
            condition={permissions?.Staffs?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="staff/staff-design/:staffId"
        element={
          <ConditionalRoute
            Element={<StaffDesign />}
            condition={permissions?.Staffs?.update}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-staff"
        element={
          <ConditionalRoute
            Element={<DeletedStaff />}
            condition={permissions?.Staffs?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="job-roles"
        element={
          <ConditionalRoute
            Element={<JobRolesRoute />}
            condition={permissions?.JobRoles?.read}
            // condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="shifts"
        element={
          <ConditionalRoute
            Element={<ShiftsRoute />}
            condition={permissions?.Shifts?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-shifts"
        element={
          <ConditionalRoute
            Element={<DeletedShifts />}
            condition={permissions?.Shifts?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="black-list"
        element={
          <ConditionalRoute
            Element={<Blacklist />}
            condition={permissions?.BlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-staff-black-list"
        element={
          <ConditionalRoute
            Element={<DeletedStaffBlackList />}
            condition={permissions?.BlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="asset-types"
        element={
          <ConditionalRoute
            Element={<AssetTypes />}
            condition={permissions?.AssetsType?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-asset-types"
        element={
          <ConditionalRoute
            Element={<DeletedAssetTypes />}
            condition={permissions?.AssetsType?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="attendance"
        element={
          <ConditionalRoute
            Element={<Attendance />}
            condition={permissions?.StaffAttendance?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* LateRequestsAttendance */}
      <Route
        path="attendance/late-requests-attendance"
        element={
          <ConditionalRoute
            Element={<LateRequestsAttendance />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="channels"
        element={
          <ConditionalRoute
            Element={<Channels />}
            condition={permissions?.Channels?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-channels"
        element={
          <ConditionalRoute
            Element={<DeletedChannels />}
            condition={permissions?.Channels?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="channels/:channelId"
        element={
          <ConditionalRoute
            Element={<ChannelUsers />}
            condition={permissions?.Channels?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="channels/history/:channelId"
        element={
          <ConditionalRoute
            Element={<ChannelHistory />}
            condition={permissions?.Chats?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="groups"
        element={
          <ConditionalRoute
            Element={<Groups />}
            condition={permissions?.Groups?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-groups"
        element={
          <ConditionalRoute
            Element={<DeletedGroups />}
            condition={permissions?.Groups?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="groups/:groupId"
        element={
          <ConditionalRoute
            Element={<GroupUsers />}
            condition={permissions?.Groups?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="groups/history/:groupId"
        element={
          <ConditionalRoute
            Element={<GroupChats />}
            condition={permissions?.Chats?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="privateChats"
        element={
          <ConditionalRoute
            Element={<PrivateChats />}
            condition={permissions?.PrivateChat?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="privateChats/singlePrivatechat"
        element={
          <ConditionalRoute
            Element={<SinglePrivateChatUser />}
            condition={permissions?.PrivateChat?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="privateChatsHistory"
        element={
          <ConditionalRoute
            Element={<PrivateChatsHistory />}
            condition={permissions?.PrivateChatHistory?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="privateChatsHistory/:privateChatId"
        element={
          <ConditionalRoute
            Element={<SinglePrivateChat />}
            condition={permissions?.PrivateChatHistory?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="roomReservations"
        element={
          <ConditionalRoute
            Element={<RoomReservations />}
            condition={permissions?.RoomReservations?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="allReservations"
        element={
          <ConditionalRoute
            Element={<AllReservations />}
            condition={permissions?.RoomReservations?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* contact Person */}
      <Route
        path="contactPerson"
        element={
          <ConditionalRoute
            Element={<ContactPerson />}
            condition={permissions?.ContactPersons?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-contact-person"
        element={
          <ConditionalRoute
            Element={<DeletedContactPerson />}
            condition={permissions?.ContactPersons?.read}
            redirectTo="/site-layout"
          />
        }
      />

      {/* profile */}
      <Route
        path="profile"
        element={
          <ConditionalRoute
            Element={<Profile />}
            condition={permissions?.Profile?.read}
            redirectTo="/site-layout"
          />
        }
      >
        <Route
          path="general"
          element={
            <ConditionalRoute
              Element={<GeneralProfile />}
              condition={permissions?.Profile?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="changePassword"
          element={
            <ConditionalRoute
              Element={<ChangePassword />}
              condition={permissions?.Profile?.read}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="permissions"
          element={
            <ConditionalRoute
              Element={<MyPermissions />}
              condition={permissions?.Profile?.read}
              redirectTo="/site-layout"
            />
          }
        />
      </Route>
      {/* visitors black list */}
      <Route
        path="visitors-black-list"
        element={
          <ConditionalRoute
            Element={<VisitorsBlackList />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="my-visitor-requests"
        element={
          <ConditionalRoute
            Element={<MyVisitorRequests />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="visitor-requests"
        element={
          <ConditionalRoute
            Element={<VisitorRequests />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="visitor-requests-history"
        element={
          <ConditionalRoute
            Element={<VisitorRequestsHistory />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="visitor-entry-exit"
        element={
          <ConditionalRoute
            Element={<VisitorEntryExit />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="visitor-entry-exit-logs"
        element={
          <ConditionalRoute
            Element={<VisitorEntryExitLogs />}
            condition={permissions?.VisitorBlackLists?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* public settings */}
      <Route
        path="public-settings"
        element={
          <ConditionalRoute
            Element={<PublicSettings />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      {/* transaction */}
      <Route
        path="transaction"
        element={
          <ConditionalRoute
            Element={<Transaction />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="containers-transaction"
        element={
          <ConditionalRoute
            Element={<TransactionContainers />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="containers-caregories"
        element={
          <ConditionalRoute
            Element={<TransactionContainersCategories />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="containers-status"
        element={
          <ConditionalRoute
            Element={<TransactionStatus />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="containers-status-categories"
        element={
          <ConditionalRoute
            Element={<TransactionStatusCategories />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="containers-location"
        element={
          <ConditionalRoute
            Element={<TransactionContainerLocations />}
            condition={permissions?.Transactions?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* drugs tests */}
      <Route
        path="drugs-test"
        element={
          <ConditionalRoute
            Element={<DrugsTest />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-drugs-test"
        element={
          <ConditionalRoute
            Element={<DeletedDrugsTest />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="drug-test-result/:id"
        element={
          <ConditionalRoute
            Element={<DrugTestResult />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      {/* courses */}
      <Route
        path="courses"
        element={
          <ConditionalRoute
            Element={<Courses />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="deleted-courses"
        element={
          <ConditionalRoute
            Element={<DeletedCourses />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="courses-categories"
        element={
          <ConditionalRoute
            Element={<CoursesCategory />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      {/* staff documents */}
      <Route
        path="staff-documents/:staffId"
        element={
          <ConditionalRoute
            Element={<StaffDocuments />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />

      {/* activityLog */}
      <Route
        path="activity-log"
        element={
          <ConditionalRoute
            Element={<ActivityLogTabBar />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      >
        <Route
          path="user"
          element={
            <ConditionalRoute
              Element={<ActivityLogUser />}
              condition={true}
              redirectTo="/site-layout"
            />
          }
        />
        <Route
          path="users"
          element={
            <ConditionalRoute
              Element={<ActivityLog />}
              condition={true}
              redirectTo="/site-layout"
            />
          }
        />
      </Route>

      {/* working activity */}
      <Route
        path="/working-activity"
        element={
          <ConditionalRoute
            Element={<WorkingActivity />}
            condition={permissions?.WorkConfirmation?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* vactions types */}
      <Route
        path="/vacation-types"
        element={
          <ConditionalRoute
            Element={<VacationRequestTypes />}
            condition={permissions?.VacationRequest?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* vactions requests */}
      <Route
        path="/vacation-requests"
        element={
          <ConditionalRoute
            Element={<VacationRequests />}
            condition={permissions?.VacationRequest?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* vactions requests History */}
      <Route
        path="/vacation-requests-history"
        element={
          <ConditionalRoute
            Element={<VacationRequests />}
            condition={permissions?.VacationRequest?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* OverTime Requests */}
      <Route
        path="/overtime-requests"
        element={
          <ConditionalRoute
            Element={<OvertimeRequests />}
            condition={permissions?.OvertimeRequest?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* overtime requests history */}
      <Route
        path="/overtime-requests-history"
        element={
          <ConditionalRoute
            Element={<OvertimeRequests />}
            condition={permissions?.OvertimeRequest?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* staff salary */}
      <Route
        path="/staff-salary"
        element={
          <ConditionalRoute
            Element={<StaffSalary />}
            condition={permissions?.StaffSalary?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-staff-salary"
        element={
          <ConditionalRoute
            Element={<DeletedStaffSalary />}
            condition={permissions?.StaffSalary?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* salary record */}
      <Route
        path="/salary-record"
        element={
          <ConditionalRoute
            Element={<SalaryRecord />}
            condition={permissions?.StaffSalaryRecord?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-salary-record"
        element={
          <ConditionalRoute
            Element={<DeletedSalaryRecord />}
            condition={permissions?.StaffSalaryRecord?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* opration plan */}
      <Route
        path="/operation-plan"
        element={
          <ConditionalRoute
            Element={<OperationPlan />}
            condition={true}
            // condition={permissions?.OperationPlan?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/operation-plan/:operationPlanId/tasks"
        element={
          <ConditionalRoute
            Element={<OperationPlanTasks />}
            condition={true}
            // condition={permissions?.OperationPlan?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/operation-plan/:operationPlanId/points"
        element={
          <ConditionalRoute
            Element={<OperationPlanPoints />}
            condition={true}
            // condition={permissions?.OperationPlan?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-operation-plan"
        element={
          <ConditionalRoute
            Element={<DeletedSalaryRecord />}
            condition={true}
            // condition={permissions?.OperationPlan?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* buffet */}
      <Route
        path="/buffets"
        element={
          <ConditionalRoute
            Element={<Buffet />}
            condition={permissions?.Buffet?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-buffet"
        element={
          <ConditionalRoute
            Element={<DeletedBuffet />}
            condition={permissions?.Buffet?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/buffets/products/:buffetId"
        element={
          <ConditionalRoute
            Element={<BuffetProducts />}
            condition={permissions?.Buffet?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* buffet orders */}
      <Route
        path="/buffet-orders"
        element={
          <ConditionalRoute
            Element={<BuffetOrders />}
            condition={permissions?.BuffetOrders?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/buffet-orders/:buffetId/history"
        element={
          <ConditionalRoute
            Element={<BuffetOrdersHistory />}
            condition={permissions?.BuffetOrders?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-buffet-orders"
        element={
          <ConditionalRoute
            Element={<DeletedBuffetOrders />}
            condition={permissions?.BuffetOrders?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* buffet groups */}
      <Route
        path="/buffet-groups"
        element={
          <ConditionalRoute
            Element={<BuffetGroups />}
            condition={permissions?.BuffetGroups?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/deleted-buffet-groups"
        element={
          <ConditionalRoute
            Element={<DeletedBuffetGroups />}
            condition={permissions?.BuffetGroups?.read}
            redirectTo="/site-layout"
          />
        }
      />
      {/* tickets */}
      <Route
        path="/send-ticket"
        element={
          <ConditionalRoute
            Element={<SendTicket />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/tickets-settings"
        element={
          <ConditionalRoute
            Element={<TicketsSettings />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/all-tickets"
        element={
          <ConditionalRoute
            Element={<Tickets />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/my-tickets"
        element={
          <ConditionalRoute
            Element={<MyTickets />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/all-tickets/:id"
        element={
          <ConditionalRoute
            Element={<TicketsDetails />}
            condition={true}
            redirectTo="/site-layout"
          />
        }
      />

      {/* minutes of meetings */}
      <Route
        path="/minutes-of-meetings"
        element={
          <ConditionalRoute
            Element={<MinutesOfMeetings />}
            condition={permissions?.MinutesOfMeetings?.read}
            redirectTo="/site-layout"
          />
        }
      />

      <Route
        path="/minutes-of-meetings/minutes/:meetingId"
        element={
          <ConditionalRoute
            Element={<Minutes />}
            condition={permissions?.MinutesOfMeetings?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/minutes-of-meetings/agendas/:meetingId"
        element={
          <ConditionalRoute
            Element={<Agendas />}
            condition={permissions?.MinutesOfMeetings?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/minutes-of-meetings/attendee-users/:meetingId"
        element={
          <ConditionalRoute
            Element={<AttendeeUsers />}
            condition={permissions?.MinutesOfMeetings?.read}
            redirectTo="/site-layout"
          />
        }
      />
      <Route
        path="/minutes-of-meetings/tasks/:meetingId"
        element={
          <ConditionalRoute
            Element={<Tasks />}
            condition={permissions?.MinutesOfMeetings?.read}
            redirectTo="/site-layout"
          />
        }
      />
    </Route>
    <Route
      path="/reservation/:qr"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <RoomsReservation />
        </Suspense>
      }
    />
    <Route
      path="/reservation/room-details/:id/:qr"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <RoomDetails />
        </Suspense>
      }
    />
    <Route
      path="/reservation/requests"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <ReservationRequests />
        </Suspense>
      }
    />
    <Route
      path="/reservation/requests/status/:phoneNumber"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <ReservationStatus />{" "}
        </Suspense>
      }
    />
    {/* <Route
        path=""
        element={
          <Suspense
            fallback={
              <div className="fixed inset-0 flex items-center justify-center">
                <LoadingData />
              </div>
            }
          >
            <Home />
          </Suspense>
        }
      /> */}
    {/* <Route
        path="/our-work"
        element={
          <Suspense
            fallback={
              <div className="fixed inset-0 flex items-center justify-center">
                <LoadingData />
              </div>
            }
          >
            <OurWork />
          </Suspense>
        }
      />
      <Route
        path="/about-us"
        element={
          <Suspense
            fallback={
              <div className="fixed inset-0 flex items-center justify-center">
                <LoadingData />
              </div>
            }
          >
            <AboutUs />
          </Suspense>
        }
      />
      <Route
        path="/contact-us"
        element={
          <Suspense
            fallback={
              <div className="fixed inset-0 flex items-center justify-center">
                <LoadingData />
              </div>
            }
          >
            <ContactUs />
          </Suspense>
        }
      /> */}
    {/* client qrcode */}
    <Route
      path="/qr/:siteId/:qrcode"
      element={
        <Suspense
          fallback={
            <div className="fixed inset-0 flex items-center justify-center">
              <LoadingData />
            </div>
          }
        >
          <ClientQrCodeRedirct />
        </Suspense>
      }
    />
    {/* <Route path="testing" element={<Testing />} /> */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default routes;
